import { render, staticRenderFns } from "./custom-app-drawer.vue?vue&type=template&id=42b1b41a&"
import script from "./custom-app-drawer.vue?vue&type=script&lang=js&"
export * from "./custom-app-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports